import { useEffect, useState } from "react";
import axios from "axios";
import { MailX } from "lucide-react";

let cached = null;

export const PreviewBadge = () => {
  const [preview, setPreview] = useState(cached);
  useEffect(() => {
    if (cached !== null) return;
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/settings/public`)
      .then(r => { cached = !!r.data?.is_preview; setPreview(cached); })
      .catch(() => {});
  }, []);
  if (!preview) return null;
  return (
    <span
      className="ml-1 sm:ml-2 shrink-0 inline-flex items-center gap-1 px-1.5 sm:px-2 py-1 sm:py-0.5 border border-amber-500/60 bg-amber-500/15 text-amber-600 font-mono text-[10px] font-bold tracking-wider uppercase"
      title="This is the preview copy. Email sending is disabled; only production sends email."
      data-testid="preview-badge"
    >
      <MailX className="w-3.5 h-3.5 sm:w-3 sm:h-3" />
      <span className="hidden sm:inline">Preview, emails off</span>
    </span>
  );
};
